import React from 'react';

const Loader = (props) => {
  const { style } = props || {};
  return <div className="loading">Loading&#8230;</div>;
};

export default Loader;
